/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../components/ConfirmationPrompt';
import AnimatedModel from '../../components/Animation/AnimatedModel';
import { dataService } from '../../services/data.services';
import GlobalContext from '../../components/Context/GloablContext';
import Table from './components/Table';
import TopBarWithShadow from '../../components/TopBar/TopBarWithShadow';
import { Branch, DateFilter } from './BranchSlice';
import EmptyScreenBranch from './components/EmptyScreen';
import CardHeader from '../../components/CardHeader';
import moment from 'moment';
import { removeAssociationSelection } from '../ManageAssociation/AssociationSlice';
import Debounce from '../../CommonMethods/Debounce';
import { FetchBranch } from '../../CommonMethods/FetchBranch';
import { hanldeBranch } from '../auth/authSlice';

const ManageBranch = () => {
    const { setToastErrorMessage, setToastmessage,isBranchUpdate, setIsBranchUpdate, setIsInactiveBranch,isSideNavBar  } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const BranchList = useSelector(state => state.BranchSlice);
    const { List} = BranchList
    const {userType}=useSelector(state=>state.auth)
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('');
    const [FilterData, setFilterData] = useState({});
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [filterCount, setFilterCount] = useState(0)
    const [fistLoading, setFirstLoading] = useState(false)
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const placeholderOptions = [
        'Branch Name',
        'POC Email Address',
        'GSTIN',
        'PAN'
    ];
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setSearchParams({ page_number:  1 })
    }

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    /* The above code is defining a function called `getBranch` using the `useCallback` hook in React.
    This function is an asynchronous function that makes a dispatch to the `Branch` action with the
    `searchParams` as an argument. It then checks the response from the dispatch and sets the
    appropriate loading and empty screen messages based on the response data. If there are no
    matching records found, it sets the `emptyScreenMessage` to "No matching records found." If the
    total count of records is less than the current page number, it sets the `emptyScreenMessage` to
    "No data */
    const getBranch = useCallback(async () => {
        try {
            setLoading(true);
            const allowedParams = ['page_number', 'search', 'filter', 'city', 'status', 'start_date', 'end_date'];
            const filteredParams = new URLSearchParams();

            allowedParams.forEach((param) => {
                if (searchParams.has(param)) {
                    filteredParams.set(param, searchParams.get(param));
                }
            });
            dispatch(Branch(filteredParams.toString())).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data.total_count === 0 && searchParams.get('filter')===null ) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found.")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            updateFilterCheckBox()
            if(confirmationState.status==='Deactivate' || confirmationState.status==='Activate')
            {
                const allbraches =await FetchBranch()
                            
            }
        } catch (error) {
            handleLoadData()
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        // if(!searchParams.get('sort')) {
        //     handleSearchParams('sort', `created_at+desc`)
        // }
        setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        getBranch();
        return(()=>{
            dispatch(removeAssociationSelection())
        })
    }, [searchParams]);

    useEffect(()=>{
        getFilterData();
    },[])

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`admin-users/reset-password/${confirmationState.item.email_address}`:`branch/${confirmationState.item._id}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }else{
                body={
                    "status":confirmationState.status==='Deactivate'?false:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            if(confirmationState.status === 'Reset Password'){
                setToastmessage('Reset password email sent successfully')
            } else{
                setToastmessage(`Branch ${state} successfully`);
            }
            handleConformationClick();
            setLoading(true)
            getBranch();
            if(confirmationState.status==="Deactivate" || confirmationState.status==="Activate")
            {
                const allbraches =await FetchBranch()
                dispatch(hanldeBranch(allbraches));
                const id = confirmationState.item._id;
                const branchDetails = JSON.parse(localStorage.getItem('branch_details'));
                const bid = branchDetails?.id;
                const matchedBranch = allbraches.find(item => item.id === bid);
                if (id === bid) {
                    setIsBranchUpdate(!isBranchUpdate)
                    const isInactive = (matchedBranch.status!=undefined&&!matchedBranch.status);
                    const branchNameWithStatus = matchedBranch.name + (isInactive ? " (Inactive)" : "");
                    localStorage.setItem('branch_details', JSON.stringify({ name: matchedBranch.branch_name, id: id, status:!isInactive, branchNameWithStatus: branchNameWithStatus }));
                    setIsInactiveBranch(isInactive)
                }
            }
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong. Please try again")
        }
    }
    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        const hasStartDate = FilterCheckbox.hasOwnProperty('start_date');
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 && item !="end_date") {
                count += 1
            }
            if (item === "end_date" && !hasStartDate){
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)

        } else {
            setFilterCount(0)
        }
    }

    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
            status: searchParams.get('status'),
            city : searchParams.get('city')
        };
        // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
                    
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        const hasStartDate = filteredFilterState.hasOwnProperty('start_date');
            
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0  && (item !="end_date" ) ) {
                count += 1
            }
            if (item === "end_date" && !hasStartDate){
                count += 1
            }
        })
        setFilterCount(count)
    };

    /**
     * The function `handleApplyFilter` is used to apply filters to a search and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        setEmptyScreenMessage("It seems there's nothing to display here.");
        let params = Object.fromEntries(searchParams);
        if(type) {
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? moment(val.$d).format("YYYY-MM-DD") : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            delete params.filter
            Object.keys(FilterCheckbox).map((item) => {
                delete params[item]
            })
            delete params.start_date
            delete params.end_date
            setSearchParams({ ...params})
            setFilterCheckBox([])
        }
        getCount(type)
    }
    
    /**
     * The function `getFilterData` is an asynchronous function that retrieves filter data from an API,
     * sets the filter data in state, and performs some additional operations on the filter data.
     */
    const getFilterData = async () => {
        try {
            const response = await dataService.GetAPI(`branch/list-filters`);
            let resp = response.data.data;
            setFilterData(resp);
            let filter_val = {};
            Object.keys(resp).map((item) => {
                let params = Object.fromEntries(searchParams);
                Object.keys(params).map((subitem) => {
                    if (item === subitem) {
                        filter_val[item] = params[item].split(',');
                    }
                    if (subitem === 'start_date' || subitem === 'end_date') {
                        filter_val[subitem] = params[subitem];
                    }
                });
                setFilterCheckBox(filter_val);
                let count = 0;
                Object.keys(filter_val).map((item) => {
                    if (filter_val[item]?.length !== 0) {
                        if (item !== "end_date") {
                            count += 1;
                        }
                    }
                });
                setFilterCount(count);
            });
            dispatch(DateFilter(filter_val));
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error("Error occurred while fetching filter data:", error);
        }
    };

    return (
        <>
            <CardHeader noPadding>          
                <TopBarWithShadow
                    AddButton={true}
                    showAddButtonalways={true}
                    SearchInput={true}
                    Tittle={'Branches'}
                    AddButtonName={'Onboard Branch'}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    optimizedFn={optimizedFn}
                    isClick='/manage-branches/onboard-new-branch'
                    ApplyFilter={true}
                    FilterData={FilterData}
                    handleApplyFilter={handleApplyFilter}
                    FilterCheckbox={FilterCheckbox}
                    setFilterCheckBox={setFilterCheckBox}
                    filterCount={filterCount}
                    searchParams={searchParams}
                    filterFromPage={'Branches_List'}
                    customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                    ManageBranchListing
                /><CardHeader body >
                    {loading ? <ItemShimmer />
                        : <>
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                setLoading={setLoading}
                                searchParams={searchParams}
                                isSideNavBar={isSideNavBar}
                            />
                            {(List.total_count > 10) && <Pagination
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)}
                                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                            />}
                        </> 
                    }</CardHeader>
            </CardHeader>            
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status && confirmationState.status==='Reset Password'  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Branch`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for` : confirmationState.status} ${confirmationState?.item?.branch_name} ?`}
                        buttonName = {confirmationState.status === 'Reset Password' ? "Reset" : confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }

            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status && confirmationState.status != 'Reset Password'  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Branch`} `}
                        additionalMessage={`${confirmationState.status==='Deactivate' ? 'Deactivating this branch will also deactivate all associated branch users.':
                            'Inactivating this branch will also inactivate all associated branch users.'}`}
                        message = {`Do you want to continue?`}
                        buttonName = {`Continue`}
                        dialogueWidth={'500px'}
                        textPosition={'text-start'}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default ManageBranch;
